// extracted by mini-css-extract-plugin
module.exports =  {"grey_800":"#95979d"};